
import { Injectable } from '@nestjs/common';
import { getManager, In } from 'typeorm';
import { DevicesAdapater } from './devices.adapater';
import { RfCodeCreateRequest } from './dto';
import { RfCodesEntity } from './entity/rf-codes.entity';
import { DeviceRepo } from './repository/device.repository';
import { RfCodeRepo } from './repository/rf-code.repository';
import { DevicesDto } from './dto/device.dto';
import { DevicesResponse, RfCodeModel, RfCodesResponse } from '@gtpl/shared-models/canteen-management';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import appSettings from 'apps/services/config';

@Injectable()
export class DevicesService {
    constructor(
        private rfCodeRepo: RfCodeRepo,
        private deviceRepo: DeviceRepo,
        private deviceAdapter: DevicesAdapater,

    ) {

    }

    /**
     * creates the rf code
     * @param rfCodeCreateReq 
     * @returns 
     */

    async createRfCode(rfCodeCreateReq: RfCodeCreateRequest): Promise<RfCodesResponse> {
        const rfModels: RfCodeModel[] = [];
        for (const rfCode of rfCodeCreateReq.rfCodes) {
            const rfEntity = new RfCodesEntity();
            rfEntity.rfCode = rfCode;
            rfEntity.createdUser = rfCodeCreateReq.username;
            const savedRfEntity = await this.rfCodeRepo.save(rfEntity);
            rfModels.push(new RfCodeModel(rfEntity.rfCode));
        }
        return new RfCodesResponse(true, 0, 'RF code saved successfully', rfModels);
    }

    /**
    * create the device 
    * @param devicesDto 
    * @returns 
    */


    async createDevices(devicesDto: DevicesDto): Promise<DevicesResponse> {
        devicesDto.deviceId = null;
        const savedDev = await this.deviceRepo.save(this.deviceAdapter.convertCreateDtoEntity(devicesDto));
        const dtoObj = new DevicesDto(null, savedDev.deviceCode, savedDev.deviceName, savedDev.description, savedDev.createdUser);
        console.log('----dto obj----', dtoObj)
        return new DevicesResponse(true, 11838, 'Device values are saved successfully', [dtoObj]);
    }

    /**
     * deletes the rf code record
     */

    async deleteRfCode(rfCodeCreateReq: RfCodeCreateRequest): Promise<RfCodesResponse> {
        await this.rfCodeRepo.delete({ rfCode: In(rfCodeCreateReq.rfCodes), isActive: true });
        return new RfCodesResponse(true, 0, 'RF code deleted successfully');
    }

    /**
     * deletes the rf code record
     */

    async deleteDevices(req: DevicesDto): Promise<DevicesResponse> {
        const device = await this.deviceRepo.findOne({ where: { deviceId: req.deviceId } });
        if (!device) {
            throw new ErrorResponse(0, 'Device not found');
        }
        await this.deviceRepo.delete({ deviceId: req.deviceId });
        return new DevicesResponse(true, 0, ' delete for the device successfully', []);
    }

    /**
     * gets the rf code
     */

    async getRfCodeRecordByRfCode(rfCodeReq: RfCodeCreateRequest): Promise<RfCodesResponse> {
        const rfCode = rfCodeReq.rfCodes[0];
        const rfCodeRec = await this.rfCodeRepo.findOne({ select: ['rfCode'], where: { rfCode: rfCode, isActive: true } });
        if (!rfCode) {
            throw new ErrorResponse(0, 'No rf code exist');
        }
        const rfCodeModel = new RfCodeModel(rfCode);
        return new RfCodesResponse(true, 0, 'RF code deleted successfully', [rfCodeModel]);
    }


    async getAllRfCode(): Promise<RfCodesResponse> {
        const allRfCodes = await this.rfCodeRepo.find({});
        if (allRfCodes.length === 0) {
            throw new ErrorResponse(11843, 'No RfCode Exist in given input')
        }
        const dtos = allRfCodes.map(rfCode => new RfCodeModel(rfCode.rfCode))
        return new RfCodesResponse(true, 11844, 'All RfCodes Retrived Successfully', dtos)
    }

    async getAllDevices(): Promise<DevicesResponse>{
        const allDevices = await this.deviceRepo.find({});
        if(allDevices.length === 0) {
            throw new ErrorResponse(11843,'No Device EXist in given input');
        }
        const dtos = allDevices.map(device => new DevicesDto(device.deviceId, device.deviceCode,device.deviceName,device.description,device.createdUser));
        return new DevicesResponse(true,11844, 'All Devices Retrived SuccessFully', dtos);
    }

    // async getAllDevices(): Promise<CommonResponse> {
    //     const manager = getManager()
    //     const query = ` SELECT device_code as deviceCode , device_name as deviceName , description AS description from ` + appSettings.cms_db + `.device WHERE device_id > 0 `
    //     const data = await manager.query(query)
    //     if (data.length > 0) {
    //         return new CommonResponse(true, 1111, 'Data Retreived sucessfully', data)
    //     } else {
    //         return new CommonResponse(true, 1111, 'No data found')
    //     }
    // }
}
